import { RootState } from '../../store/store';

const loadingNotify = (state: RootState) => state.loadingNotify;

export { default as loadingNotifySelectors } from './selectors';

export default {
    loadingNotify
};
